import React, { useEffect, useState } from 'react';
import ZaraTable from '../../custom-components/ZaraTable/ZaraTable';
import useServerApi from '../../../hooks/useServerApi';
import {
    Modal,
    ModalOverlay,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalContent,
    ModalFooter,
    Button,
    Box,
    useMediaQuery,
    Link,
} from '@chakra-ui/react';

const InvoiceDialog = ({ open, onClose }) => {
    const [{ get }] = useServerApi();
    const [isMobile] = useMediaQuery('(max-width: 480px)');

    const [invoices, setInvoices] = useState([]);
    useEffect(() => {
        if (open) {
            get('/rest_endpoints/stripe/crud/get_invoices').then(([success, res]) => {
                if (success) {
                    const formatted = (res?.invoices || []).map((inv) => {
                        // Format amount_due as $<amount_due>
                        const amount_due = `$${inv.amount_due}`;
                        // Format created as mm/dd/yy
                        const date = new Date(inv.created);
                        const mm = String(date.getMonth() + 1).padStart(2, '0');
                        const dd = String(date.getDate()).padStart(2, '0');
                        const yy = String(date.getFullYear()).slice(-2);
                        const created = `${mm}/${dd}/${yy}`;
                        // invoice_pdf as Chakra Link
                        const invoice_pdf = (
                            <Link href={inv.invoice_pdf} isExternal color="blue.500" fontWeight="medium">
                                PDF
                            </Link>
                        );

                        return {
                            ...inv,
                            amount_due,
                            created,
                            invoice_pdf,
                        };
                    });
                    setInvoices(formatted);
                } else {
                    setInvoices([]);
                    console.error('Failed to fetch invoices', res);
                }
            });
        }
    }, [open, get]);

    const headers = [
        { key: 'amount_due', value: 'Amount Due', sortable: true },
        { key: 'invoice_pdf', value: 'Invoice PDF', sortable: false },
        { key: 'created', value: 'Created', sortable: true },
    ];

    return (
        <Modal isCentered isOpen={open} onClose={onClose} motionPreset='slideInBottom'>
            <ModalOverlay />
            <ModalContent width="90%" maxW="600px">
                <ModalHeader fontSize='18px' lineHeight='28px' fontWeight='700' textAlign='left'>
                    Past Invoices
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Box mb='34px'>
                        <ZaraTable headers={headers} rows={invoices} />
                    </Box>
                </ModalBody>
                <ModalFooter p={isMobile ? '12px 16px' : '16px 24px'}>
                    <Button onClick={onClose} variant='secondary' width={isMobile ? '100%' : 'auto'}>
                        Close
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default InvoiceDialog;
